import React, { useEffect, useState } from "react";
import { useNextEngagement } from "./store";
import { useNavigate } from "react-router-dom";
import CardDiv from "modules/common/card-div/CardDiv";
import { isEmpty } from "lodash";
import secureLocalStorage from 'react-secure-storage';

function NextCall() {
  const { nextEngagementData, nextEngagements } = useNextEngagement();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);
  const [nextCallId, setNextCallId] = useState();
  useEffect(() => {
    secureLocalStorage.removeItem("previousCustomer");
    setNextCallId();
    nextEngagements();
  }, []);

  useEffect(() => {
    if (!isEmpty(nextEngagementData)) {
      setNextCallId(nextEngagementData.case_id);
    } else {
      setNextCallId();
    }
  }, [nextEngagementData]);

  useEffect(() => {
    if (nextEngagementData) {
      const timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown && prevCountdown - 1);
      }, 1000);

      setTimeout(() => {
        clearInterval(timer);
        nextCallId &&
          window.location.href.includes("next-call") &&
          navigate(`/next-call/${nextCallId}`);
      }, 3000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [nextCallId]);

  return (
    <CardDiv
      component={
        <div>
          {countdown ? (
            <h4>Redirecting in {countdown} seconds...</h4>
          ) : (
            !nextCallId && <h4>No Calls to attend</h4>
          )}
        </div>
      }
      title={"Next Call"}
    />
  );
}

export default NextCall;
